import { ChangeEvent } from "react";
import { InputProps, Inputs } from "../Inputs";
import { RequiredMark } from "../Inputs.style";

interface InputTextProps extends InputProps {
  defaultValue?: string | number;
  step?: string;
  onChange?: (e: ChangeEvent<HTMLInputElement>) => void;
  onBlur?: (e: ChangeEvent<HTMLInputElement>) => void;
  required?: boolean;
}

export const InputText = ({
  type = "text",
  size = "md",
  direction = "column",
  id,
  label,
  placeholder,
  width,
  name,
  disabled,
  onChange,
  onBlur,
  defaultValue,
  register,
  step,
  value,
  required = false,
}: InputTextProps) => {
  return (
    <Inputs
      id={id && id}
      label={label && label}
      size={size}
      width={width}
      direction={direction}
    >
      <>
        {required && <RequiredMark>*</RequiredMark>}
        <input
          name={name}
          id={id && id}
          placeholder={placeholder && placeholder}
          type={type}
          disabled={disabled}
          onChange={onChange}
          onBlur={onBlur}
          value={value}
          defaultValue={defaultValue}
          step={step}
          {...register}
        />
      </>
    </Inputs>
  );
};
